import { faGem } from "@jewlr/pro-light-svg-icons/faGem"
import { faMedal } from "@jewlr/pro-light-svg-icons/faMedal"
import { faRotateLeft } from "@jewlr/pro-light-svg-icons/faRotateLeft"
import { faTruckBolt } from "@jewlr/pro-light-svg-icons/faTruckBolt"
import { faStar, faStarHalf } from "@jewlr/pro-solid-svg-icons"

import Divider from "components/ui/divider"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { jewlr_t, IS_JEWLR, IS_GE_CHECKOUT } from "helpers/application"

import EmptyOutCart from "../empty-out-cart"
import Help from "../help-footer"

import AcceptPayments from "./accept-payments"

const Footer = () => {
  const is_ge_checkout = IS_GE_CHECKOUT()
  return (
    <>
      {IS_JEWLR() && (
        <>
          <div className="contained tablet:pt-0 pt-16">
            <Divider className="tablet:block bg-grey-20 mb-40 mt-12 hidden" />
            <div className="gap-30 tablet:gap-32 desktop:gap-56 mb-30 tablet:mb-0 flex justify-center">
              <div className="pb-10 text-center">
                <FontAwesomeIcon
                  className="text-30 tablet:text-48 pb-8 text-black"
                  icon={faTruckBolt}
                />
                <h5 className="body-sm mx-auto font-medium">
                  FREE
                  <br />
                  {jewlr_t("terms.Shipping")}
                </h5>
              </div>
              <div className="pb-10 text-center">
                <FontAwesomeIcon
                  className="text-30 tablet:text-48 pb-8 text-black"
                  icon={faMedal}
                />
                <h5 className="body-sm mx-auto font-medium">
                  One-Year
                  <br />
                  Warranty
                </h5>
              </div>
              <div className="pb-10 text-center">
                <FontAwesomeIcon
                  className="text-30 tablet:text-48 pb-8 text-black"
                  icon={faRotateLeft}
                />
                <h5 className="body-sm mx-auto font-medium">
                  {is_ge_checkout ? "30" : "99"}-Day
                  <br />
                  Returns
                </h5>
              </div>
              <div className="pb-10 text-center">
                <FontAwesomeIcon
                  className="text-30 tablet:text-48 pb-8 text-black"
                  icon={faGem}
                />
                <h5 className="body-sm mx-auto font-medium">
                  Made in
                  <br />
                  North America
                </h5>
              </div>
            </div>
            <Media className="mb-40 px-48 text-center" lessThan="tablet">
              <p className="text-18 mb-6 font-bold">Customer Reviews</p>
              <p className="text-12 mb-6 font-medium">
                {jewlr_t("terms.Jewelry")} And Customer Experience Is Our
                Passion, And Our Customers Love Us For It.
              </p>
              <p className="text-18 mb-6 font-bold">50K+</p>
              <div className="flex justify-center gap-2">
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStarHalf}
                />
              </div>
            </Media>
          </div>
          <Media className="contained px-16" lessThan="tablet">
            <Help />
          </Media>
        </>
      )}
      <EmptyOutCart />
      <Media lessThan="tablet">
        <AcceptPayments />
      </Media>
    </>
  )
}
export default Footer
